class MainBlogTab extends HTMLElement {
    constructor() {
        super();

        const mainBlogId = document.querySelector(".js-main-blog").getAttribute('data-section-id');
        this.sections = {
            main: {
                sectionId: mainBlogId,
                nodeId: "mainBlog"
            }
        };

        this.ajaxblogEl = document.querySelector(`#${this.sections.main.nodeId}`);
        this.tabWrapperEl = this; 
        this.blogTabHeaders = this.querySelectorAll("[js-blog-tab-header]");

        this.init();
    }

    init() {
        if (this.blogTabHeaders.length) {
            this.blogTabHeaders.forEach(tabHeader => {
                const handler = (evt) => {
                    evt.preventDefault();
                    this.fetchTabContent(evt.currentTarget);
                };

                tabHeader.addEventListener('click', handler);
                tabHeader.addEventListener('touchstart', handler, { passive: false });
            });
        }
    }

    fetchTabContent(target) {
        this.blogTabHeaders.forEach(tab => tab.classList.remove('active'));
        target.classList.add('active');

        const tagHandle = target.getAttribute('href');
        this.updateHistoryState(tagHandle);

        const blogPostsContainer = this.ajaxblogEl.querySelector('.blog-posts-container');
        if (blogPostsContainer) blogPostsContainer.classList.add('is-fetching');

        fetch(`${tagHandle}?section_id=${this.sections.main.sectionId}`)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newContent = doc.querySelector(`#${this.sections.main.nodeId}`).innerHTML;
                this.ajaxblogEl.innerHTML = newContent;

                document.dispatchEvent(new CustomEvent('pagination:init'));

                this.scrollTabWrapperIntoView();
            });
    }

    scrollTabWrapperIntoView() {
        const rect = this.tabWrapperEl.getBoundingClientRect();
        const offset = 112; 
        const scrollTop = window.pageYOffset + rect.top - offset;

        if (rect.top < 0 || rect.bottom > window.innerHeight) {
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }

    updateHistoryState(handle) {
        const newUrl = `${window.location.protocol}//${window.location.host}${handle}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
}

customElements.define('main-blog-tab', MainBlogTab);

class BlogPagination {
    constructor() {
        this.ajaxblogEl = document.querySelector('.js-main-blog');
        this.tabWrapperEl = document.querySelector('main-blog-tab');  
        this.bindPaginationLinks();
        document.addEventListener('pagination:init', () => {
            this.bindPaginationLinks();
        });
    }

    bindPaginationLinks() {
        const paginationLinks = this.ajaxblogEl.querySelectorAll('.pagination a, .js-pagination a');

        if (paginationLinks.length) {
            paginationLinks.forEach(paginationLink => {
                const handler = (evt) => {
                    evt.preventDefault();
                    const url = paginationLink.getAttribute('href');
                    if (url) {
                        this.fetchPaginatedContent(url);
                    }
                };

                paginationLink.addEventListener('click', handler);
                paginationLink.addEventListener('touchstart', handler, { passive: false });
            });
        }
    }
    fetchPaginatedContent(pageHandle) {
        const blogPostsContainer = this.ajaxblogEl.querySelector('.blog-posts-container');
        const paginationWrapper = this.ajaxblogEl.querySelector('.pagination-wrapper');

        if (blogPostsContainer) blogPostsContainer.classList.add('is-fetching');

        const fetchUrl = `${pageHandle}&section_id=${this.ajaxblogEl.getAttribute('data-section-id')}`;

        fetch(fetchUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newPosts = doc.querySelector('.blog-posts-container');
                const newPagination = doc.querySelector('.pagination-wrapper');

                if (newPosts && blogPostsContainer) {
                    blogPostsContainer.innerHTML = newPosts.innerHTML;
                }

                if (newPagination && paginationWrapper) {
                    paginationWrapper.innerHTML = newPagination.innerHTML;
                }

                this.bindPaginationLinks();

                this.scrollTabWrapperIntoView();
            })
            .finally(() => {
                if (blogPostsContainer) blogPostsContainer.classList.remove('is-fetching');
            });

        const newUrl = `${window.location.protocol}//${window.location.host}${pageHandle}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    scrollTabWrapperIntoView() {
        const rect = this.tabWrapperEl.getBoundingClientRect();
        const offset = 112; 
        const scrollTop = window.pageYOffset + rect.top - offset;

        if (rect.top < 0 || rect.bottom > window.innerHeight) {
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new BlogPagination();
});
